import Vue from 'vue';
import ReInitPaymentButton from './components/ReInitPaymentButton';
import ReInitPaymentContainer from './components/ReInitPaymentContainer';

Vue.component('mollie-re-init-payment-btn', ReInitPaymentButton);
Vue.component('mollie-re-init-payment-container', ReInitPaymentContainer);


if (localStorage.getItem('mollieApplePayChecked') !== 'true') {

    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        // Add ApplePay to the method selection in your checkout
        $.ajax(
            {
                type: 'PUT',
                url: '/rest/mollie/activate_apple_pay',
            }
        )
            .done(
                function () {
                    console.log('apple pay active');
                }
            )
            .fail(
                function (msg) {
                }
            );

    }

    localStorage.setItem('mollieApplePayChecked', 'true');
}


// WEBPACK FOOTER //
// ./src/main.js